import axios from 'axios';
import Facebook from '../../assets/svg/facebook.svg';
import { BASE_URL } from "../../config/axios";
import React, { useState, useEffect } from 'react';
import { formattedDateLong } from '../Date';
import { Flex } from 'antd';
import Loader from '../Loader';

// Shared card renderer — use this inside all three tab components

// --- Shared helpers (component ke bahar) ---

const createMarkup = (content) => {
    const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
    return { __html: content.replace(linkRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`) };
};

const handlePriority = (value) => {
    if (value == 1 || value == 'high') return <button className="priority-button-small font-weight600 color-tab-red">High</button>
    else if (value == 2 || value == 'medium') return <button className="priority-button-small font-weight600 color-tab-yellow">Medium</button>
    else if (value == 3 || value == 'low') return <button className="priority-button-small font-weight600 color-tab-blue">Low</button>
    else return null;
};

// const renderTaskCard = (data, index) => (
//     <div key={index} style={{
//         background: '#fff',
//         border: '1px solid #e8f0fb',
//         borderRadius: '12px',
//         padding: '14px 16px',
//         marginBottom: '10px',
//         boxShadow: '0 1px 4px rgba(37,118,188,0.06)',
//     }}>
//         <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
//             {/* Number badge */}
//             <div style={{
//                 minWidth: '25px', height: '25px', borderRadius: '8px',
//                 background: 'rgb(37, 118, 188)',
//                 color: '#fff', fontSize: '11px', fontWeight: 700,
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 flexShrink: 0,
//             }}>
//                 {index + 1}
//             </div>

//             <div style={{ flex: 1 }}>
//                 {/* By / To row */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
//                     <span className="font-weight500 font-size-text" style={{ color: '#162952' }}>
//                         By: <strong>{data.assignedbyname}</strong>
//                     </span>
//                     <span className="font-weight500 font-size-text" style={{ color: '#162952' }}>
//                         To: <strong>{data.concern_personname}</strong>
//                     </span>
//                 </div>

//                 {/* Due On / Priority row */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
//                     <span className="font-size-text" style={{ color: '#6b7280', fontWeight: 500 }}>
//                         Due On: <span style={{ color: '#162952' }}>{formattedDateLong(data.due_date)}</span>
//                     </span>
//                     <span className="font-size-text" style={{ color: '#6b7280', fontWeight: 500, display: 'flex', alignItems: 'center', gap: '6px' }}>
//                         Priority: {handlePriority(data.priority)}
//                     </span>
//                 </div>

//                 {/* Task content */}
//                 <p className="dashcomp-announcement-p font-weight400 font-size-label" style={{ margin: 0 }}>
//                     <span dangerouslySetInnerHTML={createMarkup(data.task)} />
//                 </p>
//             </div>
//         </div>
//     </div>
// );

const renderTaskCard = (data, index) => (
    <div key={index} className="task-card-dashboard">
        <div className="task-card-dashboard__wrapper">

            <div className="task-card-dashboard__badge">
                {index + 1}
            </div>

            <div className="task-card-dashboard__content">

                <div className="task-card-dashboard__users">
                    <span className="task-card-dashboard__by font-weight500 font-size-text">
                        By: <strong>{data.assignedbyname}</strong>
                    </span>

                    <span className="task-card-dashboard__to font-weight500 font-size-text">
                        To: <strong>{data.concern_personname}</strong>
                    </span>
                </div>

                <div className="task-card-dashboard__meta">
                    <span className="task-card-dashboard__due font-size-text">
                        Due On:
                        <span className="task-card-dashboard__date">
                            {formattedDateLong(data.due_date)}
                        </span>
                    </span>

                    <span className="task-card-dashboard__priority font-size-text">
                        Priority: {handlePriority(data.priority)}
                    </span>
                </div>

                <p className="task-card-dashboard__task dashcomp-announcement-p font-weight400 font-size-label">
                    <span dangerouslySetInnerHTML={createMarkup(data.task)} />
                </p>

            </div>
        </div>
    </div>
);

// Announcements Tab
const Inprogresstask = () => {
    const [inprogresstask, setInprogresstask] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const getInprogresstask = async () => {
        setBuffering(true); // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/wfm/taskbyempp/${sessionStorage.getItem('emp_code')}/pending/`);
            setInprogresstask(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        getInprogresstask();
    }, []);


    // return (
    //     <div className="dashcomp-task-cards" style={{ height: '237px' }}  >

    //         {/* For Testing Purpose Only! */}
    //         {/* <div className="d">
    //           <h5>1. Announcement</h5>
    //           <img src={Calaneder} alt="Desk Icon"
    //                       style={{ color: 'red', marginRight: '8px',
    //                       width: '16px', height: '16px', marginTop: "-4px" }}
    //                   />
    //       </div> */}

    //         {buffer ? <Loader container={true} /> :
    //             inprogresstask.map((data, index) => {
    //                 const formattedDate = new Date(data.date).toLocaleString('en-US', {
    //                     month: 'long',
    //                     day: 'numeric',
    //                     year: 'numeric',
    //                 });
    //                 return (
    //                     <div className=''>
    //                         <div className="dashcomp-task-card-data">
    //                             <div style={{ display: "flex" }}>
    //                                 <h3 style={{ flex: 2 }} className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{index + 1}.{"  "} <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  "> By:</span> {data.assignedbyname}</h3>
    //                                 <h3 style={{ flex: 1 }} className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{"     "} <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  "> To:</span> {data.concern_personname}</h3>
    //                             </div>
    //                             <div style={{ display: "flex" }}>
    //                                 <span style={{ flex: 2 }} className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">

    //                                     Due On:    {formattedDateLong(data.due_date)}
    //                                 </span>
    //                                 <span style={{ flex: 1 }} className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">

    //                                     Priority:    {handlePriority(data.priority)}
    //                                 </span>

    //                             </div>
    //                             <p className="dashcomp-announcement-p font-weight400  font-size-text">
    //                                 <span dangerouslySetInnerHTML={createMarkup(data.task)} />
    //                             </p>
    //                         </div>
    //                     </div>
    //                 )
    //             })
    //         }
    //     </div>
    // )
    return (
        <div className="dashcomp-task-cards" style={{ height: '237px', overflowY: 'auto', paddingRight: '4px' }}>
            {buffer ? <Loader container={true} /> :
                inprogresstask.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280', gap: '8px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgb(216,233,255)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="2" width="6" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12l2 2 4-4" />
                        </svg>
                        <span style={{ fontSize: '13px' }}>No pending tasks</span>
                    </div>
                ) :

                    inprogresstask.map((data, index) => renderTaskCard(data, index))
            }
        </div>
    );
}


// Ondeadline Tab
const Ondeadline = () => {
    const [inprogresstask, setInprogresstask] = useState([]);
    const [buffer, setBuffering] = useState(true);

    useEffect(() => {
        const getInprogresstask = async () => {
            setBuffering(true);
            try {
                const res = await axios.get(`${BASE_URL}/wfm/taskbyempp/${sessionStorage.getItem('emp_code')}/inprocess/`);
                setInprogresstask(res.data);
            } catch (err) {
                console.error(err.message);
            } finally {
                setBuffering(false);
            }
        };
        getInprogresstask();
    }, []);


    return (
        // <div className="dashcomp-task-cards" style={{ height: '237px' }} >

        //     {/* For Testing Purpose Only! */}
        //     {/* <div className="d">
        //       <h5>1. Announcement</h5>
        //       <img src={Calaneder} alt="Desk Icon"
        //                   style={{ color: 'red', marginRight: '8px',
        //                   width: '16px', height: '16px', marginTop: "-4px" }}
        //               />
        //   </div> */}

        //     {inprogresstask.map((data, index) => {
        //         const formattedDate = new Date(data.date).toLocaleString('en-US', {
        //             month: 'long',
        //             day: 'numeric',
        //             year: 'numeric',
        //         });
        //         return (
        //             <>
        //                 <div className="dashcomp-task-card-data">
        //                     <div style={{ display: "flex" }}>
        //                         <h3 style={{ flex: 2 }} className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{index + 1}.{"  "} <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  "> By:</span> {data.assignedbyname}</h3>
        //                         <h3 style={{ flex: 1 }} className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{"     "} <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  "> To:</span> {data.concern_personname}</h3>
        //                     </div>
        //                     <div style={{ display: "flex" }}>
        //                         <span style={{ flex: 2 }} className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">

        //                             Due On:    {formattedDateLong(data.due_date)}
        //                         </span>
        //                         <span style={{ flex: 1 }} className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">

        //                             Priority:    {handlePriority(data.priority)}
        //                         </span>

        //                     </div>
        //                     <p className="dashcomp-announcement-p font-weight400  font-size-text">
        //                         <div dangerouslySetInnerHTML={createMarkup(data.task)} />
        //                     </p>
        //                 </div>
        //             </>
        //         )
        //     })
        //     }
        // </div>

        <div className="dashcomp-task-cards" style={{ height: '237px', overflowY: 'auto', paddingRight: '4px' }}>
            {buffer ? <Loader container={true} /> :
                inprogresstask.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280', gap: '8px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgb(216,233,255)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="2" width="6" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12l2 2 4-4" />
                        </svg>
                        <span style={{ fontSize: '13px' }}>No in-progress tasks</span>
                    </div>
                ) :
                    inprogresstask.map((data, index) => renderTaskCard(data, index))
            }
        </div>
    )
}

// Completed Tab
const Completed = () => {
    const [inprogresstask, setInprogresstask] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const getInprogresstask = async () => {
        setBuffering(true); // Start Bufferi  ng
        try {
            const res = await axios.get(`${BASE_URL}/wfm/taskbyempp/${sessionStorage.getItem('emp_code')}/completed/`);
            setInprogresstask(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    useEffect(() => {
        getInprogresstask();
    }, []);



    // return (
    //     <div className="dashcomp-task-cards" style={{ height: '237px' }} >

    //         {/* For Testing Purpose Only! */}
    //         {/* <div className="d">
    //           <h5>1. Announcement</h5>
    //           <img src={Calaneder} alt="Desk Icon"
    //                       style={{ color: 'red', marginRight: '8px',
    //                       width: '16px', height: '16px', marginTop: "-4px" }}
    //                   />
    //       </div> */}

    //         {buffer ? <Loader container={true} /> :
    //             inprogresstask.map((data, index) => {
    //                 const formattedDate = new Date(data.date).toLocaleString('en-US', {
    //                     month: 'long',
    //                     day: 'numeric',
    //                     year: 'numeric',
    //                 });
    //                 return (
    //                     <>
    //                         <div className="dashcomp-task-card-data">
    //                             <div style={{ display: "flex" }}>
    //                                 <h3 style={{ flex: 2 }} className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{index + 1}.{"  "} <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  "> By:</span> {data.assignedbyname}</h3>
    //                                 <h3 style={{ flex: 1 }} className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{"     "} <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  "> To:</span> {data.concern_personname}</h3>
    //                             </div>
    //                             <div style={{ display: "flex" }}>
    //                                 <span style={{ flex: 2 }} className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">

    //                                     Due On:    {formattedDateLong(data.due_date)}
    //                                 </span>
    //                                 <span style={{ flex: 1 }} className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">

    //                                     Priority:    {handlePriority(data.priority)}
    //                                 </span>

    //                             </div>
    //                             <p className="dashcomp-announcement-p font-weight400  font-size-text">
    //                                 <div dangerouslySetInnerHTML={createMarkup(data.task)} />
    //                             </p>
    //                         </div>
    //                     </>
    //                 )
    //             })
    //         }
    //     </div>
    // )

    return (
        <div className="dashcomp-task-cards" style={{ height: '237px', overflowY: 'auto', paddingRight: '4px' }}>
            {buffer ? <Loader container={true} /> :
                inprogresstask.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280', gap: '8px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgb(216,233,255)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="2" width="6" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12l2 2 4-4" />
                        </svg>
                        <span style={{ fontSize: '13px' }}>No completed tasks</span>
                    </div>
                ) :
                    inprogresstask.map((data, index) => renderTaskCard(data, index))
            }
        </div>
    );
}

// Completed Tab
const Closed = () => {
    const [inprogresstask, setInprogresstask] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const getInprogresstask = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/wfm/taskbyempp/${sessionStorage.getItem('emp_code')}/close/`);
            setInprogresstask(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        getInprogresstask();
    }, []);



    return (
        <div className="dashcomp-task-cards" style={{ height: '237px', overflowY: 'auto', paddingRight: '4px' }}>
            {buffer ? <Loader container={true} /> :
                inprogresstask.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280', gap: '8px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgb(216,233,255)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="2" width="6" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12l2 2 4-4" />
                        </svg>
                        <span style={{ fontSize: '13px' }}>No closed tasks</span>
                    </div>
                ) :
                    inprogresstask.map((data, index) => renderTaskCard(data, index))
            }
        </div>
    );
}

// View All Projects Tab
const Allprojects = () => {
    const [allprojects, setAllprojects] = useState([]);
    const [buffer, setBuffering] = useState(true);

    useEffect(() => {
        const getAllprojects = async () => {
            setBuffering(true);
            try {
                const res = await axios.get(`${BASE_URL}/attandance/in-progress-task/`);
                setAllprojects(res.data);
            } catch (err) {
                console.error(err.message);
            } finally {
                setBuffering(false);
            }
        };
        getAllprojects();
    }, []);


    // return (
    //     <div className="dashcomp-bg-cards" style={{ height: '237px' }} >

    //         {/* For Testing Purpose Only! */}
    //         {/* <div className="d">
    //           <h5>1. Announcement</h5>
    //           <img src={Calaneder} alt="Desk Icon"
    //                       style={{ color: 'red', marginRight: '8px',
    //                       width: '16px', height: '16px', marginTop: "-4px" }}
    //                   />
    //       </div> */}

    //         {allprojects.map((data, index) => {
    //             const formattedDate = new Date(data.date).toLocaleString('en-US', {
    //                 month: 'long',
    //                 day: 'numeric',
    //                 year: 'numeric',
    //             });
    //             return (
    //                 <>
    //                     <div className="EmployeeDashboad-notification-card">
    //                         <h3 className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{index + 1}.{"  "}{data.title}</h3>
    //                         <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">
    //                             <img src={Facebook} alt="Desk Icon"
    //                                 style={{
    //                                     color: 'red', marginRight: '8px',
    //                                     width: '16px', height: '16px', marginTop: "-4px"
    //                                 }}
    //                             />
    //                             {formattedDate}
    //                         </span>
    //                         <p className="dashcomp-announcement-p font-weight400  font-size-text">
    //                             <div dangerouslySetInnerHTML={createMarkup(data.description)} />
    //                         </p>
    //                     </div>
    //                 </>
    //             )
    //         })
    //         }
    //     </div>
    // )

    return (
        <div className="dashcomp-bg-cards" style={{ height: '237px', overflowY: 'auto', paddingRight: '4px' }}>
            {buffer ? <Loader container={true} /> :
                allprojects.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6b7280', gap: '8px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgb(216,233,255)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="2" width="6" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12l2 2 4-4" />
                        </svg>
                        <span style={{ fontSize: '13px' }}>No projects found</span>
                    </div>
                ) :
                    allprojects.map((data, index) => (
                        <div key={index} style={{ background: '#fff', border: '1px solid #e8f0fb', borderRadius: '12px', padding: '14px 16px', marginBottom: '10px', boxShadow: '0 1px 4px rgba(37,118,188,0.06)' }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                <div style={{ minWidth: '28px', height: '28px', borderRadius: '8px', background: 'rgb(37, 118, 188)', color: '#fff', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    {index + 1}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <h3 className="dashcomp-announcement-heading font-weight500 font-size-subheading" style={{ margin: '0 0 6px 0', color: '#162952' }}>
                                        {data.title}
                                    </h3>
                                    <p className="dashcomp-announcement-p font-weight400 font-size-text" style={{ margin: 0 }}>
                                        <span dangerouslySetInnerHTML={createMarkup(data.description)} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
            }
        </div>
    );
}


// Main Component
// const TaskInformation = () => {

//     const [toggleState, setToggleState] = useState(1);
//     return (
//         <div className='backgroundmain-task'>
//             <div className='dashboardcomponent-task width-40vw' >
//                 {/* <div className="task-heading">
//                     <h6>Your Tasks</h6>
//                 </div> */}
//                 <div>
//                     <div className="bloc-tabs-task">
//                         <button
//                             className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(1)}
//                         >
//                             Pending
//                         </button>
//                         {/* <button
//                             className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(2)}
//                         >
//                             In Progress
//                         </button> */}
//                         <button
//                             className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(3)}
//                         >
//                             Completed
//                         </button>

//                         <button
//                             className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(4)}
//                         >
//                             Closed
//                         </button>
//                         {/* <button
//                         className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                         onClick={() => setToggleState(5)}
//                     >
//                         View All Projects
//                     </button> */}
//                     </div>
//                 </div>
//                 <div className="content-tabs">
//                     {toggleState === 1 ? <Inprogresstask /> : null}
//                     {toggleState === 2 ? <Ondeadline /> : null}
//                     {toggleState === 3 ? <Completed /> : null}
//                     {toggleState === 4 ? <Closed /> : null}
//                     {toggleState === 5 ? <Allprojects /> : null}
//                 </div>
//             </div>
//         </div>
//     )
// }

// Main Component
const TaskInformation = () => {
    const [toggleState, setToggleState] = useState(1);

    return (
        <div className='backgroundmain-task'>
            <div className='dashboardcomponent-task'>

                {/* Tabs */}
                {/* <div style={{ display: 'flex', gap: '0', borderBottom: '2px solid #e8f0fb', marginBottom: '14px' }}>
                    {[{ label: 'Pending', id: 1 }, { label: 'Completed', id: 3 }, { label: 'Closed', id: 4 }].map(tab => (
                        <button key={tab.id}
                            onClick={() => setToggleState(tab.id)}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                padding: '8px 18px',
                                fontSize: '13px', fontWeight: toggleState === tab.id ? 600 : 400,
                                color: toggleState === tab.id ? 'rgb(37, 118, 188)' : '#6b7280',
                                borderBottom: toggleState === tab.id ? '2px solid rgb(37, 118, 188)' : '2px solid transparent',
                                marginBottom: '-2px', transition: 'all 0.2s',
                            }}>
                            {tab.label}
                        </button>
                    ))}
                </div> */}
                <div className="task-tab-bar">
                    {[{ label: 'Pending', id: 1 }, { label: 'Completed', id: 3 }, { label: 'Closed', id: 4 }].map(tab => (
                        <button key={tab.id}
                            onClick={() => setToggleState(tab.id)}
                            className={`task-tab-btn ${toggleState === tab.id ? 'active' : ''}`}>
                            {tab.label}
                        </button>
                    ))}
                </div>
                {/* Content */}
                <div className="content-tabs" style={{ margin: '15px' }}>
                    {toggleState === 1 ? <Inprogresstask /> : null}
                    {toggleState === 2 ? <Ondeadline /> : null}
                    {toggleState === 3 ? <Completed /> : null}
                    {toggleState === 4 ? <Closed /> : null}
                    {toggleState === 5 ? <Allprojects /> : null}
                </div>

                {/* Bottom Feature Strip */}
                <div
                    className="task-feature-strip"

                >
                    {[
                        {
                            icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>,
                            title: 'Track Progress', sub: 'Stay on top'
                        },
                        {
                            icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
                            title: 'Meet Deadlines', sub: 'Never miss a due date'
                        },
                        {
                            icon: <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="2" width="6" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><path d="M9 12l2 2 4-4" /></svg>,
                            title: 'Stay Organized', sub: 'All tasks in one place'
                        },
                    ].map((item, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                            <div style={{
                                width: '32px', height: '32px', borderRadius: '8px',
                                background: 'rgb(216, 233, 255)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0,
                            }}>
                                {item.icon}
                            </div>
                            <div>
                                <div style={{ fontSize: '12px', fontWeight: 600, color: '#162952' }}>{item.title}</div>
                                <div style={{ fontSize: '11px', color: '#6b7280' }}>{item.sub}</div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default TaskInformation